const FILE_BASE_URL = (import.meta.env.VITE_API_BASE_URL || 'https://ndsh.staging.hntsz.com').replace(/\/$/, '');

export function getFileAccessUrl(url?: string, paramName: 'f' | 'path' = 'f') {
  if (!url) return '';
  if (/^(?:https?:|data:|blob:|file:)/i.test(url)) return url;
  if (url.startsWith('/api/uploadFile/')) return `${FILE_BASE_URL}${url}`;
  if (url.startsWith('/uploadFile/')) return `${FILE_BASE_URL}${url}`;
  if (url.startsWith('/api/v1/files/download')) return `${FILE_BASE_URL}${url}`;
  return `${FILE_BASE_URL}/api/v1/files/download?${paramName}=${encodeURIComponent(url)}`;
}
